import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./VideoComponent.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BASE_URL } from "../../constant";

const VideoComponent = () => {
  const videoRefs = [useRef(null), useRef(null), useRef(null)]; // Array of refs

  const [muteStates, setMuteStates] = useState([true, true, true]); // Array to hold mute states
  const [videos, setVideos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await fetch(`${BASE_URL}/homepage/video/get-videos`);
        const data = await response.json();
        setVideos(data || []); // Store the entire video objects, not just URLs
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchVideos();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    initialSlide: 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: true,
    centerMode: true,
    centerPadding: "15%",
    nextArrow: (
      <div className="slick-next-btn">
        <i className="fas fa-chevron-right"></i>
      </div>
    ),
    prevArrow: (
      <div className="slick-prev-btn">
        <i className="fas fa-chevron-left"></i>
      </div>
    ),
  };

  const handleMuteToggle = (index) => {
    const newMuteStates = [...muteStates];
    newMuteStates[index] = !newMuteStates[index];
    setMuteStates(newMuteStates);
    if (videoRefs[index].current) {
      videoRefs[index].current.muted = newMuteStates[index];
    }
  };

  const handleButtonClick = (redirectUrl) => {
    if (redirectUrl) {
      navigate(redirectUrl);
    } else {
      navigate("/shop");
    }
  };

  if (videos?.length < 3) {
    return <div>Loading videos...</div>;
  }

  return (
    <div className="video-container">
      <div className="desktop-view">
        {videos?.map((video, index) => (
          <div key={video.id} className="video-segment">
            <video
              ref={videoRefs[index]}
              className="video"
              autoPlay
              loop
              muted={muteStates[index]}
            >
              <source src={video.url} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <button
              className="sound-toggle-button"
              onClick={() => handleButtonClick(video.redirectUrl)}
            >
              Explore Now
            </button>
          </div>
        ))}
      </div>
      <div className="mobile-view">
        <Slider {...settings}>
          {videos?.map((video, index) => (
            <div key={video.id} className="video-segment">
              <video
                ref={videoRefs[index]}
                className="video"
                autoPlay
                loop
                muted={muteStates[index]}
              >
                <source src={video.url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <button
                className="sound-toggle-button"
                onClick={() => handleButtonClick(video.redirectUrl)}
              >
                Explore Now
              </button>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default VideoComponent;
